import { createStackNavigator } from "@react-navigation/stack"
import type { RootStackParamList } from "src/types.d"

/**
 * A root stack navigator is often used for displaying modals on top of all other content.
 * https://reactnavigation.org/docs/modal
 */
export const RootStack = createStackNavigator<RootStackParamList>()
